import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { getImoDcsReportSummary } from "../../../../../../services/ChildReportService";
import ReportSummaryOld from "./DCSReportSummaryOldReport/DCSReportSummaryOldReport";
import ReportSummaryNew from "./DCSReportSummaryNew/DCSReportSummary";
import DcsSummaryView from "../DcsSummaryView/DcsSummaryView";

const MergedDcsReportSummary = () => {
    const { selectedReportDetails: reportDetails, reportFlagDetails: reportFlags } = useSelector(
        (state) => state.reports, shallowEqual
    );
    const [dcsReportSummary, setDcsReportSummary] = useState();

   

    const ReportComponent = DcsSummaryView;

    return <ReportComponent/>;
};


export default MergedDcsReportSummary;
